import { Box, Chip, type ChipProps, Skeleton, Typography } from '@mui/material';

import { CardGallery } from '../CardGallery/CardGallery';
import { CardIconList } from '../CardIconList/CardIconList';
import type { PhotoEvidenceItem } from '../PhotoEvidenceList/PhotoEvidenceList';

export const Card = ({
  images,
  title,
  subtitle,
  chip,
  isSelected,
  children,
}: {
  images?: PhotoEvidenceItem[];
  title: React.ReactNode;
  subtitle?: string;
  chip?: ChipProps & {
    isLoading?: boolean;
  };
  isSelected?: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <Box
      sx={(theme) => ({
        ':hover': {
          boxShadow: theme.shadows[1],
          cursor: 'pointer',
        },
        backgroundColor: theme.palette.background.paper,
        border: isSelected ? `4px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.border.main}`,
        borderRadius: 2,
        padding: 2,
      })}
    >
      {images ? (
        <Box mb={2}>
          <CardGallery images={images} />
        </Box>
      ) : null}

      <Typography variant="body1" fontWeight="bold" data-testid="card-title" component="div">
        {title}
      </Typography>

      {subtitle || chip ? (
        <Box display="flex" width="100%" justifyContent="space-between" alignItems="center">
          {subtitle ? (
            <Typography variant="body2" data-testid="card-subtitle">
              {subtitle}
            </Typography>
          ) : null}

          {chip?.isLoading ? <Skeleton variant="rounded" width={30} /> : null}

          {chip?.label ? <Chip size="small" {...chip} /> : null}
        </Box>
      ) : null}

      {children ? (
        <Box mt={2} mb={-1}>
          {children}
        </Box>
      ) : null}
    </Box>
  );
};

Card.UnorderedList = CardIconList;
